/**
 * useErrorFields — F-005 Phase 5 (IMPL-P5-001).
 *
 * React context che propaga la lista dei field-path "contestati"
 * (espansi da `expandBlockedReasonsToFields(blockedReasons)`) dal
 * `NuovaPraticaPage` (correctMode) ai singoli field component, senza
 * prop-drilling.
 *
 * Default value: `[]` — fuori dai flussi di correzione il consumer
 * riceve una lista vuota e non applica nessun highlight.
 *
 * NB: file `.tsx` perché esporta un componente React (Provider).
 */
import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

const ErrorFieldsContext = createContext<string[]>([]);

export interface ErrorFieldsProviderProps {
  children: ReactNode;
  value: string[];
}

export function ErrorFieldsProvider({ children, value }: ErrorFieldsProviderProps) {
  return (
    <ErrorFieldsContext.Provider value={value}>
      {children}
    </ErrorFieldsContext.Provider>
  );
}

/**
 * Restituisce la lista dei field path `ContractDraft` contestati
 * (dai `blockedReasons` dell'operatore). Array vuoto fuori dai flussi
 * di correzione.
 */
export function useErrorFields(): string[] {
  return useContext(ErrorFieldsContext);
}
